export const getDisplayLabel = (
  label: string,
  filterCategory: string,
): string => {
  if (filterCategory === "availability" && label === "Current") {
    return "Available now";
  }
  return label;
};
